import React from 'react';
import { NavLink as RRNavLink } from 'react-router-dom';
import HomeMenuNav from '../components/HomeMenuNav';
import ImageStrip from '../components/ImageStrip';
import Testimonial from '../components/Testimonial';
import GalleryPromo from '../components/GalleryPromo';
import BlogSection from '../components/BlogSection';
import breadImages from '../data/breadImages';
import blogPosts from '../data/blogPosts';
import { useI18n } from '../i18n/I18nContext';
import discoverStyles from '../styles/DiscoverMore.module.css';
import homeContentStyles from '../styles/HomeContent.module.css';
import styles from '../styles/Home.module.css';

const publicUrl = process.env.PUBLIC_URL || '';
const homeBreadImages = breadImages.slice(0, 7).map(image => ({
  ...image,
  src: `${publicUrl}/images/${image.file}`,
  to: `${publicUrl}/Artisan-Breads`,
}));

const Home = () => {
  const { t } = useI18n();

  return (
    <main className={styles.page}>
      <HomeMenuNav />

      <section className={styles.introSection}>
        <div className={styles.introCell}>
          <h2 className={styles.introTitle}>What is in our minds?</h2>
          <hr className={styles.introRule} />
          <p className={styles.introText}>
            Auf den folgenden Seiten finden Sie unsere leckeren Buffetvariationen,
            schmackhafte Speisen auf edlen Platten, diverse Salate, vegetarische
            Köstlichkeiten, speziellen Fingerfood, pikante Spieße, Herzhaftes und
            Süßes (Desserts). Als langjähriges Unternehmen aus Berlin.
          </p>
        </div>
        <div className={styles.introCell}>
          <img
            src={`${publicUrl}/images/brand/dish2.webp`}
            className={styles.introDish}
            alt="A selection of Grain Bites dishes"
            loading="lazy"
            decoding="async"
          />
        </div>
        <div className={styles.introCell}>
          <h2 className={styles.introTitle}>Want to explore more?</h2>
          <hr className={styles.introRule} />
          <p className={styles.introText}>
            Wir betreiben im Kreuzberger Gräfekiez eine Bar mit Schwerpunkt auf
            unprätentiösen Cocktails, Pop-up-Foodkonzepten sowie einem angewandten
            Eskapismus im Stile transatlantischer Speakeasies. Der feste Standort
            dient als schummeriger Zufluchtsort und ist gleichsam Versuchslabor
            für das Barcatering.
          </p>
          <RRNavLink
            to={`${publicUrl}/About`}
            className={styles.secretLink}
          >
            The Secret
          </RRNavLink>
        </div>
      </section>

      <ImageStrip
        eyebrow={t('imageStrip.freshFromOven')}
        items={homeBreadImages}
        columns={7}
        ariaLabel="Featured artisan breads"
      />

      <section className={`row bigline bg-look text-center ${styles.section} ${discoverStyles.section}`}>
        <div className={`col-lg-6 col-md-6 lineWrapper text-white pad ${discoverStyles.copy}`}>
          <h3 className={`lead text-center ${discoverStyles.title}`}>
            Bist du neugierig! Discover more
          </h3>
          <hr className={`hr bg-brown ${discoverStyles.rule}`} />
          <div className={`padB text-center ${discoverStyles.text}`}>
            Have a look at the delicious bits of food! You want to feel the spirit
            of Kreuzberg and taste the local food? You need lunch for your business
            meeting? Scroll around our page and explore the different meals we offer.
          </div>
        </div>
        <div className={`col-lg-6 col-md-6 lineWrapper ${discoverStyles.visual}`}>
          <RRNavLink to={`${publicUrl}/Delicious`}>
            <img
              src={`${publicUrl}/images/brand/bigsearch.webp`}
              className={`searchImg ${discoverStyles.image}`}
              alt="Explore Grain Bites food"
              loading="lazy"
              decoding="async"
            />
          </RRNavLink>
        </div>
      </section>

      <section className={`row text-align bg-clear pad line ${styles.section} ${homeContentStyles.section}`}>
        <div className="col-lg-4 col-md-4 col-sm-6 lineWrapper bg-line2">
          <h3 className="lead text-center">Good food for every moment</h3>
          <div className="padB text-center">Fresh dishes, hot drinks, cocktails, and more</div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6 text-center padB lineWrapper">
          <img
            src={`${publicUrl}/images/breads/dinkel-bread1.webp`}
            className="linepic"
            alt="Fresh artisan bread from Grain Bites"
            loading="lazy"
            decoding="async"
          />
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12 lineWrapper mobfixer">
          <h3 className="lead text-center">Creativity on the spot</h3>
          <hr className="hr bg-brown" />
          <div className="padB text-center">
            Fresh ideas, thoughtful menus, and a little Berlin spirit come together
            for every gathering.
          </div>
        </div>
      </section>

      <GalleryPromo />

      <section className={`row bigline bg-contact ${styles.section}`}>
        <div className="col-12 lineWrapper text-white pad">
          <h3 className="lead text-center">Grain Bites</h3>
          <hr className="hr bg-brown" />
          <div className="pad text-center">
            <h3><i className="fa fa-clock-o" aria-hidden="true"></i> Öffnungs Zeiten</h3>
            <div>Nachmitag: 17:00–23:00<br />Hotline catering: 9:00–19:00</div>
          </div>
        </div>
      </section>

      <Testimonial />

      <BlogSection
        eyebrow="Journal"
        title="Stories from Grain Bites"
        posts={blogPosts}
        moreLabel="View more stories"
        moreTo={`${publicUrl}/Blog`}
      />
    </main>
  );
};

export default Home;
